export default {
    methods: {
        $checkUser() {
            //console.log("checkUser:" + this.$store.state.user.isLoggedIn);
            //console.log(this.$store.state.user);
            if (this.$store.state.user.isLoggedIn) return;
            this.$AJAX.getUser().then(data => {
                 if (checkResultLog(data))
                    this.$store.dispatch('login', data);
            });
        },
        $checkAuth() {
            //console.log("checkAuth:" + this.$store.state.user.isLoggedIn);
            //console.log(this.$store.state.user);
            if (this.$store.state.user.isLoggedIn) return;
            this.$AJAX.getUser().then(data => {
                if (checkResultLog(data))
                    this.$store.dispatch('login', data);
                else
                {
                    this.$processDataMsg(data);
                    this.$router.push("login");
                }
            });
        },
        $logCredentials(creds) {
            //console.log("logCredientials");
            if (this.$store.state.user.isLoggedIn) return;

            this.$AJAX.checkLoggin(creds).then(data => {
                //-- 100 is for logging, valid is for currentUser query at each route
                
                if (checkResultLog(data)) 
                {
                    this.$store.dispatch('login', data);
                    this.$router.push(this.$store.state.appRootPath);
                } 
                else 
                    this.$processDataMsg(data);
                
            });
        },
        $isAdmin(){
            if (this.$store.state.user.role == "admin") 
                return true;
            return false;
        },
        $isManager(){
            if (this.$store.state.user.role == "manager") 
                return true;
            return false;
        },
        $isUser(){
            if (this.$checkNull(this.$store.state.user.role) ) 
                return true;
            return false;
        },        
    }
}

function checkResultLog(data) {
    if (data.code === '100' || data.status === 'valid') 
    {
        return true
    } 
    else 
    {
        return false;
    }
         
         
}



// WEBPACK FOOTER //
// ./src/mixins/auth.js